@if (art && (art === "LIEGENSCHAFT" || art === "SDR")) {
  <span>
    <h3 class="mt-3">
      <span>
        {{ "title.AmtlicheVermessung" | translate }}
      </span>
    </h3>
    <div>
      <cap-grundstueckflaeche
        [flaechenMaessigNichtAusgeschieden]="flaechenMaessigNichtAusgeschieden"
        [grundstueckId]="_grundstueckId"
        [hasRight]="hasRight"
        class="my-1">
      </cap-grundstueckflaeche>
      <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-2">
        <span class="cap-table-wrapper-title" style="font-weight: bold">
          {{ "Grundbuchpläne" | translate }}
        </span>
        <ng-container class="cap-table-wrapper-content">
          <cap-grundbuchplaene-table [hasRight]="hasRight" [listLoader]="plaeneListLoader"> </cap-grundbuchplaene-table>
        </ng-container>
      </cap-beschreibung-table-wrapper>
      <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-2">
        <span class="cap-table-wrapper-title" style="font-weight: bold">
          {{ "Lagebezeichnung" | translate }}
        </span>
        <ng-container class="cap-table-wrapper-content">
          <cap-list-loader [hasRight]="hasRight" [listLoader]="lagebezeichnungListLoader" [showTotal]="false" [showZeilenSelect]="false">
            <div class="cap-list-loader-content">
              <table class="cap-table-detail">
                <tbody>
                  <ng-template [ngTemplateOutlet]="tableRowsLagebezeichnung"></ng-template>
                </tbody>
              </table>
            </div>
          </cap-list-loader>
          <ng-template #tableRowsLagebezeichnung>
            @if (lagebezeichnungListLoader?.items) {
              @for (lagebezeichnung of lagebezeichnungListLoader?.items; track lagebezeichnung) {
                <tr>
                  <td style="width: 40%">
                    @if (isErweiterungAvPlusActive) {
                      {{
                        (lagebezeichnung.lagebezeichnungsTyp ? lagebezeichnung.lagebezeichnungsTyp : lagebezeichnungFallback) | translate
                      }}
                    } @else {
                      {{ lagebezeichnungFallback | translate }}
                    }
                  </td>
                  <td style="width: 60%">
                    <span [capHistinfo]="lagebezeichnung.histInfo">
                      {{ lagebezeichnung.adressText }}
                    </span>
                    <cap-kompakt-timepoint [item]="lagebezeichnung.histInfo?.bisTimePoint" loeschgeschaeft> </cap-kompakt-timepoint>
                  </td>
                </tr>
              }
            }
          </ng-template>
        </ng-container>
      </cap-beschreibung-table-wrapper>
      <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-2">
        <span class="cap-table-wrapper-title" style="font-weight: bold">
          {{ "Flaechenanteile" | translate }}
        </span>
        <ng-container class="cap-table-wrapper-content">
          <cap-flaechenanteil-table [grundstueckId]="_grundstueckId" [hasRight]="hasRight" [listLoader]="flaechenanteileListLoader">
          </cap-flaechenanteil-table>
        </ng-container>
      </cap-beschreibung-table-wrapper>
      @if (art !== "SDR") {
        <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
          <span class="cap-table-wrapper-title" style="font-weight: bold">
            {{ "Bodenbedeckung" | translate }}
          </span>
          <ng-container class="cap-table-wrapper-content">
            <cap-bodenbedeckung-table [hasRight]="hasRight" [listLoader]="bodenbedeckungListLoader"> </cap-bodenbedeckung-table>
          </ng-container>
        </cap-beschreibung-table-wrapper>
      }
      <cap-gebaeude
        [anzeigenAusSichtGeschaeft]="timepointService.timepointCtx.timepointListEntry?.type === 'GEO_GESCHAEFT'"
        [grundstueckId]="_grundstueckId"
        [hasRight]="hasRight"
        class="my-2">
      </cap-gebaeude>
      <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-2">
        <span class="cap-table-wrapper-title" style="font-weight: bold">
          {{ "AnmerkungAmtlicheVermessung" | translate }}
        </span>
        <ng-container class="cap-table-wrapper-content">
          <cap-avbemerkung-table [hasRight]="hasRight" [listLoader]="bemerkungListLoader"> </cap-avbemerkung-table>
        </ng-container>
      </cap-beschreibung-table-wrapper>
    </div>
  </span>
}
